module.exports = __webpack_public_path__ + "img/left-double.1c1fdd80.svg";